import React from 'react'
import { Link } from 'react-router-dom'
import useForm from '../hooks/useForm'
import api from '../api/client'
import { required, email as emailRule } from '../utils/validators'

const Footer = () => {
  // The newsletter form uses the same hook as every other form on the site, so
  // validation, double-submit guarding and analytics behave identically here.
  const { errors, isSubmitting, handleSubmit, fieldProps } = useForm({
    initialValues: { email: '', company_website: '' },
    schema: { email: [required('Enter your email address'), emailRule()] },
    formName: 'newsletter',
    successMessage: 'Subscribed. Look out for our next update.',
    onSubmit: async (v) => {
      const { data } = await api.post('/api/subscribers', {
        email: v.email,
        company_website: v.company_website,
        source_page: window.location.pathname.replace(/^\//, '') || 'home',
      });
      return data;
    },
  });

  return (
    <div>
        <footer className="footer-area footer-style-one-wrapper bg-color-footer bg_images tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="subscribe-area subscribe-style-1">
                <div className="subscribe-inner">
                  <div className="title">Subscribe to Newsletter</div>
                  <form onSubmit={handleSubmit} noValidate className="newsletter-form-1 mt--40">
                    <div className="form-honeypot" aria-hidden="true">
                      <input type="text" name="company_website" tabIndex={-1}
                        autoComplete="off" {...fieldProps('company_website')} />
                    </div>
                    <input
                      type="email"
                      placeholder="Your Email"
                      autoComplete="email"
                      {...fieldProps('email')}
                    />
                    <button
                      type="submit"
                      className="tmp-btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Subscribing…' : 'Subscribe Now'}{' '}
                      <i className="fa-sharp fa-regular fa-paper-plane"></i>
                    </button>
                    {errors.email && (
                      <p className="form-field-error" role="alert">{errors.email}</p>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-main footer-style-one">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-wrapper border-right mr--20">
                  <div className="logo">
                    <Link to="/">
                      {/* <img src="/assets/images/logo/logo-02.svg" alt="logo" /> */}
                      <img height="61" width="188" src="/assets/images/logo/starpath-logo.svg" alt="logo" />
                    </Link>
                  </div>

                  <p className="description">
                    Starparth is a forward-thinking solutions provider specializing in IT, exam infrastructure, digital marketing, and financial planning
                  </p>

                  <div className="day-time">
                    <div className="icon">
                      <i className="fa-solid fa-alarm-clock"></i>
                    </div>
                    <div className="content">
                      <div className="day">Sunday - Friday:</div>
                      <div className="time">9:00 AM – 7:00 PM</div>
                    </div>
                  </div>

                  <ul className="social-icons solid-social-icons rounded-social-icons">
                    <li>
                      <Link to="https://www.facebook.com/starparthexamination/">
                        <i className="fa-brands fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="https://x.com/Starparthtech">
                        <i className="fa-brands fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.instagram.com/starparthtechnologies/">
                        <i className="fa-brands fa-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6">
                <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                  <h5 className="ft-title">Quick Link</h5>
                  <ul className="ft-link">
                    {/*<li>
                      <Link to="/contact">About Company</Link>
                    </li>*/}
                    <li>
                      <Link to="/agency">Infra Service Provider</Link>
                    </li>
                    <li>
                      <Link to="/itconsulting">IT Consulting</Link>
                    </li>
                    <li>
                      <Link to="/marketing">Digital Marketing</Link>
                    </li>
                    <li>
                      <Link to="/financial">Financial Consulting</Link>
                    </li>
                    {/* <li>
                      <Link to="/service">Our Services</Link>
                    </li>
                    <li>
                      <Link to="/blog">News & Media</Link>
                    </li> */}
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>

                    {/* <li>
                      <Link to="/faq">Support</Link>
                    </li> */}
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper pr--15">
                  <h5 className="ft-title">Recent Post</h5>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src={require("../assets/images/footer/small-post.jpg")}
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 6</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Day tree hide from hath gathered multy
                        </h6>
                      </Link>
                    </div>
                  </div>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src={require("../assets/images/footer/small-post-2.jpg")}
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>19 March, 2026</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Saving Time Achieving Success in Business
                        </h6>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper">
                  <h5 className="ft-title">Official info:</h5>
                  <ul className="ft-link">
                    <li className="ft-location">
                      G2 Aanchal Apartment 1/55 Roshan Marg Chitrakoot Jaipur Rajasthan 302021
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-solid fa-envelope-open-text"></i>
                        </div>

                        <div className="content">
                          <span>E-mail:</span>
                          <Link to="mailto:webmaster@example.com">
                            info@starparth.com
                          </Link>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-light fa-phone"></i>
                        </div>
                        <div className="content">
                          <span>Phone:</span>
                          <Link to="tel:+919057000445">+919057000445 +919057000446</Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright-area-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-wrapper">
                <p>
                  © Copyright 2026. All Rights Reserved by{" "}
                  <Link to="https://starparth.com/">Starparth Technologies</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
